import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';

const CandidateForm = ({ onBack }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [workStatus, setWorkStatus] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const fullName = formData.get('fullName');
    const email = formData.get('email');
    const phone = formData.get('phone');
    const password = formData.get('password');
    const confirmPassword = formData.get('confirmPassword');
    const city = formData.get('city');

    if (!fullName) { toast.error("Please enter your full name."); return; }
    if (!email) { toast.error("Please enter your email address."); return; }
    if (!phone) { toast.error("Please enter your phone number."); return; }
    if (!/^\d{10}$/.test(phone)) { toast.error("Please enter exactly 10 digits for your phone number."); return; }
    if (!workStatus) { toast.error("Please select your work status (Experienced or Fresher)."); return; }
    if (workStatus === 'fresher' && !city) { toast.error("Please enter your current city."); return; }
    if (!password) { toast.error("Please enter a password."); return; }
    if (password !== confirmPassword) { toast.error("Passwords do not match!"); return; }

    setLoading(true);

    const registerData = {
      name: fullName,
      email: email,
      password: password,
      phone: phone,
      role: 'jobseeker'
    };

    const result = await register(registerData);

    if (result.success) {
      toast.success('Registration successful!');
      navigate('/');
    } else {
      toast.error(result.message || 'Registration failed');
    }

    setLoading(false);
  };

  return (
    <div style={{ animation: 'su-fade-in-up 0.3s ease-out forwards' }}>
      <div className="su-card-header">
        <button type="button" className="su-back-btn" onClick={onBack}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
          Back
        </button>
        <h2>Candidate <span>Signup</span></h2>
        <div className="su-card-underline" />
        <p>Let's get you started</p>
      </div>

      <form className="su-form" onSubmit={handleSubmit}>
        <div className="su-input-group">
          <span className="su-input-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
            </svg>
          </span>
          <input type="text" name="fullName" placeholder="Full Name" />
        </div>

        <div className="su-input-group">
          <span className="su-input-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
            </svg>
          </span>
          <input type="email" name="email" placeholder="Email Address" />
        </div>

        <div className="su-input-group">
          <span className="su-input-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.13 12 19.79 19.79 0 0 1 1.06 3.38 2 2 0 0 1 3.05 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
          </span>
          <input type="tel" name="phone" placeholder="Phone Number" />
        </div>

        {/* Work Status Cards */}
        <div className="su-work-status-container">
          <label className="su-work-status-label">Work status<span>*</span></label>
          <div className="su-work-status-cards">
            <div 
              className={`su-work-status-card ${workStatus === 'experienced' ? 'selected' : ''}`}
              onClick={() => setWorkStatus('experienced')}
            >
              <div className="su-ws-text">
                <h4>I'm experienced</h4>
                <p>I have work experience (excluding internships)</p>
              </div>
              <div className="su-ws-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                </svg>
              </div>
            </div>

            <div 
              className={`su-work-status-card ${workStatus === 'fresher' ? 'selected' : ''}`}
              onClick={() => setWorkStatus('fresher')}
            >
              <div className="su-ws-text">
                <h4>I'm a fresher</h4>
                <p>I am a student/ Haven't worked after graduation</p>
              </div>
              <div className="su-ws-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Conditional Fields based on Work Status */}
        {workStatus === 'experienced' && (
          <div className="su-dynamic-field">
            <label className="su-work-status-label">Resume<span>*</span></label>
            <div className="su-resume-upload-box">
              <button type="button" className="su-upload-btn">Upload Resume</button>
              <span className="su-upload-hint">DOC, DOCx, PDF, RTF | Max: 2 MB</span>
            </div>
            <p className="su-upload-footer-text">Recruiters give first preference to candidates who have a resume</p>
          </div>
        )}

        {workStatus === 'fresher' && (
          <div className="su-dynamic-field">
            <div className="su-city-header">
              <label className="su-work-status-label">Current city<span>*</span></label>
              <label className="su-checkbox-label">
                <input type="checkbox" name="outsideIndia" /> Outside India
              </label>
            </div>
            <div className="su-input-group su-no-icon" style={{ animation: 'none', opacity: 1 }}>
              <input type="text" name="city" placeholder="Mention the city you live in" />
            </div>
          </div>
        )}

        <div className="su-input-group">
          <span className="su-input-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          </span>
          <input type={showPassword ? "text" : "password"} name="password" placeholder="Password" />
          <span className="su-eye-icon" onClick={() => setShowPassword(!showPassword)}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {showPassword
                ? <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>
                : <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></>
              }
            </svg>
          </span>
        </div>

        <div className="su-input-group">
          <span className="su-input-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          </span>
          <input type={showConfirmPassword ? "text" : "password"} name="confirmPassword" placeholder="Confirm Password" />
          <span className="su-eye-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {showConfirmPassword
                ? <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>
                : <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></>
              }
            </svg>
          </span>
        </div>

        <button type="submit" className="su-submit-btn" disabled={loading}>
          {loading ? 'Creating account...' : 'Create Account'}
        </button>
      </form>
    </div>
  );
};

export default CandidateForm;
